// Gizmo.js
import React, { useRef, useEffect, useState } from 'react';

const Gizmo = ({ 
  targetObject,
  rotationX, 
  rotationY, 
  rotationZ, 
  panX, 
  panY, 
  translateZ,
  scale = 1
}) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const gizmoRef = useRef(null);
  
  // Update gizmo position to follow the target object
  useEffect(() => {
    if (!targetObject) return;
    
    // Get position of the target object in screen space
    const updatePosition = () => {
      const rect = targetObject.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      
      // Get position relative to the editor
      const editorRect = targetObject.parentElement.getBoundingClientRect();
      
      setPosition({
        x: centerX - editorRect.left,
        y: centerY - editorRect.top
      });
    };
    
    updatePosition();
    
    // Update position on resize or scroll
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition);
    
    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition);
    };
  }, [targetObject, panX, panY, rotationZ, scale]);

  // Gizmo is now positioned in screen space with properly centered rotation
  return (
    <div 
      ref={gizmoRef}
      style={{
        position: 'absolute',
        left: `${position.x}px`,
        top: `${position.y}px`,
        zIndex: 100,
        pointerEvents: 'none',
        // Apply rotation to the entire gizmo container
        transform: `rotate(${rotationZ}deg)`,
        transformOrigin: 'center center'
      }}
    >
      {/* X Axis */}
      <div style={{
        position: 'absolute',
        left: '0',
        top: '0',
        width: '100px',
        height: '1px',
        backgroundColor: 'red',
        transform: 'translate(0, 0)',  // Start from center and extend right
      }} />
      
      {/* Y Axis */}
      <div style={{
        position: 'absolute',
        left: '0',
        top: '-100px',  // Extend upward
        width: '1px',
        height: '100px',
        backgroundColor: 'green',
      }} />
      
      {/* Circle */}
      <div style={{
        position: 'absolute',
        left: '-8px',  // Center the 16px circle
        top: '-8px',
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        border: '1px solid blue',
        backgroundColor: 'rgba(255, 255, 255, 0.5)'
      }} />
    </div>
  );
};

export default Gizmo;